//Base Components
import BaseBoxLoader from './BaseBoxLoader';
import BaseBoxSelect from './BaseBoxSelect';
import BaseButton from './BaseButton';
import BaseEyeToggle from './BaseEyeToggle';
import BaseDropdown from './BaseDropdown';
import BaseErrorLabel from './BaseErrorLabel';
import BaseGearCard from './BaseGearCard';
import BaseTextLabel from './BaseTextLabel';
import BaseInput from './BaseInput';
import BaseLineBox from './BaseLineBox';
import BaseMessageBox from './BaseMessageBox';
import BaseModal from './BaseModal';
import BasePhotoCapture from './BasePhotoCapture';
import BasePhotoCard from './BasePhotoCard';
import BaseRadioSelect from './BaseRadioSelect';
import BaseSavingOverlay from './BaseSavingOverlay';
import BaseShadowCard from './BaseShadowCard';
import BaseSwitch from './BaseSwitch';
import BaseTagSelect from './BaseTagSelect';
import BaseTextArea from './BaseTextArea';
import BaseTooltip from './BaseTooltip';
import BaseVerticalDivider from './BaseVerticalDivider';
import BaseGrowingCenteredArrow from './BaseGrowingCenteredArrow';
import BaseFilteredBackground from './BaseFilteredBackground';
import BaseReportModal from './BaseReportModal';
import BasePhotoDetails from './BasePhotoDetails';
import BaseModalPhoto from './BaseModalPhoto';
// We no longer need to import icons, the icon component folder is being looped.
// ICONS
import IconAlpha from './icons/IconAlpha';
import IconClose from './icons/IconClose';
import IconDelete from './icons/IconDelete';
import IconDown from './icons/IconDown';
import IconEdit from './icons/IconEdit';
import IconEyeVisible from './icons/IconEyeVisible';
import IconEyeHidden from './icons/IconEyeHidden';
import IconStar from './icons/IconStar';
import IconUp from './icons/IconUp';
import IconUpload from './icons/IconUpload';
import IconCheckCircle from './icons/IconCheckCircle';
import IconRegistered from './icons/IconRegistered';
import IconHeartActive from './icons/IconHeartActive';
import IconHeart from './icons/IconHeart';
import IconInstagram from './icons/IconInstagram';
import IconTwitter from './icons/IconTwitter';
import IconFacebook from './icons/IconFacebook';
import IconYouTube from './icons/IconYouTube';
import IconGlobe from './icons/IconGlobe';
import IconReportDots from './icons/IconReportDots';
import IconExpand from './icons/IconExpand';
import IconAlphaVerify from './icons/IconAlphaVerify';
import IconCheckMark from './icons/IconCheckMark';
import IconPlay from './icons/IconPlay';
import IconFilter from './icons/IconFilter';
import BaseVideoCard from './BaseVideoCard';
import BaseModalVideo from './BaseModalVideo';
import BaseRadioGroup from "./BaseRadioGroup.vue";

export default [
	BaseBoxLoader,
	BaseBoxSelect,
	BaseButton,
	BaseEyeToggle,
	BaseDropdown,
	BaseErrorLabel,
	BasePhotoCapture,
	BaseGearCard,
	BaseTextLabel,
	BaseInput,
	BaseLineBox,
	BaseMessageBox,
	BaseModal,
	BasePhotoCard,
	BaseRadioSelect,
	BaseRadioGroup,
	BaseSavingOverlay,
	BaseShadowCard,
	BaseSwitch,
	BaseTagSelect,
	BaseTextArea,
	BaseTooltip,
	BaseVerticalDivider,
	BaseGrowingCenteredArrow,
	BaseFilteredBackground,
	BaseReportModal,
	BasePhotoDetails,
	BaseModalPhoto,
	IconAlpha,
	IconClose,
	IconDelete,
	IconDown,
	IconEdit,
	IconEyeHidden,
	IconEyeVisible,
	IconStar,
	IconUp,
	IconUpload,
    IconCheckCircle,
    IconCheckMark,
	IconRegistered,
	IconHeartActive,
	IconHeart,
	IconInstagram,
	IconTwitter,
	IconFacebook,
	IconYouTube,
	IconGlobe,
	IconReportDots,
	IconExpand,
    IconAlphaVerify,
	IconPlay,
	IconFilter,
	BaseVideoCard,
	BaseModalVideo,
];
